module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-dla-klasy-1-mj-1.ee335b48.png";